import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  width?: number;
  height?: number;
}

const CaretRightIcon: FunctionComponent<Props> = ({
  className,
  width = 6,
  height = 10,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 6 10"
    >
      <path d="M1.1342 0.801025L5.33325 5.00008L1.1342 9.19914L0.333252 8.3982L3.73137 5.00008L0.333252 1.60197L1.1342 0.801025Z" />
    </svg>
  );
};

export default CaretRightIcon;
